import {Injectable} from '@angular/core';
import {UserService} from '../shared/user.service';
import {ApiService} from '../api/api.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import {BillingCode} from './model/billing-code';

@Injectable()
export class ShareBillingCodesService {
	private billingCodes: BillingCode[] = [];
	private billingCodesLoaded: boolean = false;

	constructor(private apiService: ApiService, private userService: UserService) {
		this.loadBillingCodes();
	}

	public getBillingCodes(callback: Function): void {
		if (this.billingCodesLoaded) {
			callback(this.billingCodes);
		} else {
			setTimeout(() => {
				this.getBillingCodes(callback);
			}, 100);
		}
	};
	public loadBillingCodes(): void {
		this.apiService.getBillingCodes().subscribe((response: any) => {
			this.billingCodes = response;
			this.billingCodesLoaded = true;
		});
	};
	public refreshBillingCodes(callback: Function): void {
		this.apiService.getBillingCodes().subscribe((response: any) => {
			callback(response);
		});
	};
}



// WEBPACK FOOTER //
// ./src/app/settings/share-billing-codes.service.ts